import modules from './betr/modules'
import { getWidgets, getWidgetsViews } from './betr/widgets'

export function getLenaModules () {
  return modules
}
export function getLenaWidgets () {
  return getWidgets()
}
export function getLenaWidgetsViews () {
  return getWidgetsViews()
}

